<template lang='pug'>
	.contenido-three-columnas
		.contenedor-pleca-contenido
			.contenido
				.modulo.m1
					.contenedor-imagen
						img.image(src='~Img/Doit-02.png')
					h1
						| Quick, simple and convenient ordering process
					p.caja-texto1
						| When you are ready to request a Title 24 Energy Compliance Report from one of our knowledgeable Certified Energy Analysts, you will be taken through our quick and convenient ordering process, where you will be able to supply the format and delivery options that you require for your project.
						br
						br
						| We can deliver your report as hard-copy, and/or in PDF format. For a nominal fee, one of our Certified Energy Analysts can certify your Title24 report.
				.modulo.m2
					.contenedor-imagen
						img.image(src='~Img/Doit-03.png')
					h1
						| Work on multiple projects at the same time!
					p.caja-texto1
						| You are not limited to working on a single project, as you can have multiple projects in progress at once. Any project in progress can be opened and edited at any time. This lets you work efficiently by letting you make progress on some projects while you gather missing information on other projects.
						br
						br
						| If you have created multiple projects, you can view a list of 'in-progress' projects by clicking on the 'My Projects' button in the green menu bar.
				.modulo.m3
					.contenedor-imagen
						img.image(src='~Img/Doit-04.png')
					h1
						| Preview the status of your report and your account at any time
					p.caja-texto1
						| Once you have submitted a design and requested a report, you may no longer edit the project, but you can view the information that you supplied and the status of your report in the 'My Account' section.
						br
						br
						| The EasyTitle24.com Do-It-Yourself Takeoff tools bring you the convenience of the internet and a high-level of service and professionalism at a lower cost!
						br
						br
						app-link.btn(:to="navLinks.newProject")
							span.white
								| Get started now, Create a New Project!
</template>
<script>
export default {
	name: 'three-columns-text',
	data: function () {
		return {
			navLinks: {}
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug('NavBar config', this.navLinks)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/doit/threeColumnsText.vue